import { createReducer } from '@reduxjs/toolkit'

import { productTargetSearchTermsSummaryTableColumnsConfig } from 'configuration/tables/searchTermsTable'
import {
    DATES,
    COUNTRIES,
    REGIONS,
    BRANDS,
    CAMPAIGNS,
    CAMPAIGN_STATES,
    CAMPAIGN_TARGETING_TYPES,
    FACT_TYPES,
    METRIC_FILTERS,
    PORTFOLIOS,
    LABELS,
    TARGET_STATES,
} from 'const/filters'
import { FILTER_SETTINGS, FILTERS } from 'const/reducerKeys'
import {
    ENABLED,
    TARGET_STATE_LABELS,
    CAMPAIGN_STATES as CAMPAIGN_STATES_OPTIONS,
} from 'const/resourceStates'
import { serializeColumns } from 'helpers/tables'
import { defaultTab, getDefaultTable } from 'reducers/ui/defaults'

const initialState = {
    ...defaultTab,
    [FILTERS]: {
        [METRIC_FILTERS]: [],
        [FACT_TYPES]: [],
        [REGIONS]: [],
        [COUNTRIES]: [],
        [BRANDS]: [],
        [PORTFOLIOS]: [],
        [CAMPAIGNS]: [],
        [CAMPAIGN_STATES]: [
            {
                value: ENABLED,
                label: CAMPAIGN_STATES_OPTIONS[ENABLED],
            },
        ],
        [CAMPAIGN_TARGETING_TYPES]: [],
        [LABELS]: [],
        [TARGET_STATES]: [
            {
                value: ENABLED,
                label: TARGET_STATE_LABELS[ENABLED],
            },
        ],
    },
    [FILTER_SETTINGS]: {
        anchored: [DATES, FACT_TYPES],
        order: [
            METRIC_FILTERS,
            LABELS,
            REGIONS,
            COUNTRIES,
            BRANDS,
            PORTFOLIOS,
            CAMPAIGNS,
            CAMPAIGN_STATES,
            CAMPAIGN_TARGETING_TYPES,
            TARGET_STATES,
        ],
        displayState: {
            [METRIC_FILTERS]: true,
            [LABELS]: true,
            [REGIONS]: true,
            [COUNTRIES]: true,
            [BRANDS]: true,
            [PORTFOLIOS]: true,
            [CAMPAIGNS]: true,
            [CAMPAIGN_STATES]: true,
            [CAMPAIGN_TARGETING_TYPES]: true,
            [TARGET_STATES]: true,
        },
        userAdded: [TARGET_STATES, CAMPAIGN_STATES],
    },
    table: getDefaultTable(
        serializeColumns(productTargetSearchTermsSummaryTableColumnsConfig),
        {
            showTotalRow: true,
        }
    ),
}

export default createReducer(initialState, () => {})
